import api from './api';
import SavedSearchActions from 'actions/search/SavedSearchActions';

const interceptResponse = (response, action, args) => {
  if (action === SavedSearchActions.deleteSuccess) {
    return args;
  } else {
    return response;
  }
};

const SavedSearchSource = {
  // Delete a saved search
  delete: {
    remote(state, id) {
      return api.delete('/saved_search/' + id);
    },
    interceptResponse: interceptResponse,
    loading: SavedSearchActions.deleteLoading,
    success: SavedSearchActions.deleteSuccess,
    error: SavedSearchActions.deleteError,
  },

  // Get all the saved searches
  fetch: {
    remote(state) {
      return api.get('/saved_searches');
    },
    loading: SavedSearchActions.fetchLoading,
    success: SavedSearchActions.fetchSuccess,
    error: SavedSearchActions.fetchError,
  },

  get: {
    remote(state, savedSearchId) {
      return api.get('/saved_search/' + savedSearchId);
    },
    success: SavedSearchActions.getSuccess,
    error: SavedSearchActions.getError,
  },

  // Persist a saved search onto the backend
  persist: {
    remote(state, title, searchData, searchState) {
      return api.post('/saved_searches', {
        title: title,
        data: searchData,
        state: searchState,
      });
    },
    loading: SavedSearchActions.persistLoading,
    success: SavedSearchActions.persistSuccess,
    error: SavedSearchActions.persistError,
  },
};

export default SavedSearchSource;
